import { Routes } from "@Front/Config/Routes";
import { UserOfficeAffiliation } from "le-coffre-resources/dist/Notary";
import {
	GUEST_FOLDERS_UID,
	resolvePreferredRealOfficeUid,
} from "@Front/Utils/preferredRealOfficeUidHelpers";

export function resolveGuestExitTargetOfficeUid(params: {
	lastRealOfficeUid: string | null;
	offices: UserOfficeAffiliation[];
	primaryOfficeUid: string | null;
}): string | null {
	const preferredUid = resolvePreferredRealOfficeUid(params.lastRealOfficeUid, params.offices);
	if (preferredUid) {
		return preferredUid;
	}
	if (!params.primaryOfficeUid || params.primaryOfficeUid === GUEST_FOLDERS_UID) {
		return null;
	}
	const primaryInList = params.offices.some((office) => (office.office_uid ?? office.uid) === params.primaryOfficeUid);
	return primaryInList ? params.primaryOfficeUid : null;
}

export function buildOfficeMenuRedirectTo(nextHref: string): string {
	const trimmed = nextHref.trim();
	if (trimmed.length > 0 && trimmed !== Routes.pages.Folder.Shared) {
		return trimmed;
	}
	return Routes.pages.Folder.base;
}
